module.exports = __webpack_public_path__ + "img/75667.e7be8708.svg";